import * as React from 'react';

const Eye16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 4.5c-3.143 0-5.368 1.967-6.449 3.492L1.548 8s0 .003.003.007C2.632 9.533 4.857 11.5 8 11.5s5.367-1.967 6.449-3.492q.004-.006.003-.007V8s0-.003-.003-.007C13.367 6.467 11.143 4.5 8 4.5M.276 7.143C1.513 5.398 4.15 3 8 3s6.487 2.398 7.724 4.143a1.47 1.47 0 0 1 0 1.714C14.487 10.602 11.85 13 8 13S1.513 10.602.276 8.857a1.47 1.47 0 0 1 0-1.714"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.063 8c0 1.105-.924 2-2.063 2s-2.063-.895-2.063-2S6.86 6 8 6s2.063.895 2.063 2"
  }
));
Eye16.Size = 16;
Eye16.Title = "Eye";

export { Eye16 as default };
